const defaultSizes = {
  sm: "32px",
  md: "40px",
  lg: "48px",
  xl: "56px",
};


export default defaultSizes;